import { useEffect } from 'react'
import { EventNames } from '../../../types/misc.types'
import { trackEvent } from '../../../utils/appBridge'
import BottomSheetContent from '../BottomSheetContent'
import { SubActionButton, SubActionDisabledReason } from '../../../types/mf-execution.types'
import RenderHTML from '../../ui-components/RenderHTML'

type ExecutionActionsContentProps = {
  onDismiss: () => void
  ScreenName: string
  action: 'invest' | 'withdraw' | 'more-options'
  buttons: SubActionButton[]
}

const DisabledReasonConfig: Record<SubActionDisabledReason, null | string> = {
  [SubActionDisabledReason.PAUSED]: 'Paused by fund house',
  [SubActionDisabledReason.NOT_OFFERED]: 'Not offered by fund house',
  [SubActionDisabledReason.REGULAR]: null
}

export const ExecutionActionsContent = ({ onDismiss, ScreenName, action, buttons }: ExecutionActionsContentProps) => {
  let heading = 'Execution Actions'
  if (action === 'invest') {
    heading = 'Invest'
  } else if (action === 'withdraw') {
    heading = 'Withdraw'
  } else {
    heading = 'More Options'
  }

  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        eventId: heading,
        ScreenName
      }
    })
  }, [])
  return (
    <BottomSheetContent
      heading={heading}
      onDismiss={onDismiss}
      bottomSheetCtas={<></>}
      bottomSheetBodyClassName='!px-0'
      bottomSheetHeadingClassName='!mb-0 !text-[#232323] !text-[18px] !font-[500] !leading-[130%]'
    >
      <div className='pb-[58px]'>
        <span className='text-[#232323] text-sm font-medium leading-[21px]'>
          <div className='flex flex-col w-full items-center'>
            {buttons?.map((button, idx) => {
              return (
                <div
                  test-locator={button?.testLocator}
                  onClick={button?.isDisabled ? undefined : button?.onClick}
                  className={`flex justify-between items-center w-full px-[22px] 
                    ${idx === 0 ? '' : 'border-t border-[#F0F4F7]'} ${button?.isDisabled ? 'opacity-50 pb-4 pt-4' : 'pb-4 pt-6'}`}
                  key={button.text}
                >
                  <div className='flex gap-5 items-center flex-1'>
                    <div className={`${button?.isDisabled ? 'pb-[4px]' : 'pb-[2px]'}`}>
                      <RenderHTML innerHTMLText={button.icon ?? ''} />
                    </div>
                    <div className={`flex flex-col gap-[1px]`}>
                      <div>{button?.text}</div>
                      {button?.isDisabled &&
                        button?.disabledReason &&
                        DisabledReasonConfig?.[button?.disabledReason] && (
                          <div className='text-[12px] text-[#232323] font-[400]'>
                            {DisabledReasonConfig?.[button?.disabledReason]}
                          </div>
                        )}
                    </div>
                  </div>
                  <div className={`${button?.isDisabled ? '' : 'pb-[6px]'}`}>
                    <RenderHTML innerHTMLText={rightChevron} />
                  </div>
                </div>
              )
            })}
          </div>
        </span>
      </div>
    </BottomSheetContent>
  )
}

const rightChevron = `<svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
  <path d="M1.0957 13L6.7693 7.32635C6.94958 7.14611 6.94958 6.85389 6.7693 6.67365L1.0957 1" stroke="#232323" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`
